import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';

const InvitationHandler = ({ children }) => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const startedRef = useRef(false);
  const urlParams = new URLSearchParams(window.location.search);
  const invitation = urlParams.get('invitation');
  const organization = urlParams.get('organization');

  useEffect(() => {
    if (startedRef.current) return;
    if (isLoading || isAuthenticated) return;

    if (invitation && organization) {
      startedRef.current = true;

      loginWithRedirect({
        authorizationParams: {
          invitation,
          organization,
        },
        appState: { returnTo: '/dashboard' },
      });
    }
  }, [loginWithRedirect, invitation, organization, isLoading, isAuthenticated]);

  if (invitation && organization) {
    return (
      <div>
        <p>Processing invitation...</p>
      </div>
    );
  }

  return children || null;
};

export default InvitationHandler;
